<template>
    <FormSection title="Patient Diagnosis" type="his-section" :full-height="false">
        <template v-slot:content>
            <section>
                <div
                    class="row g-0"
                    :class="`${questionableEncounterCode ? 'has-warning px-3 py-2 mb-3' : 'px-4 py-3'}`"
                >
                    <div class="col-12 col-lg-8 col-md-8 g-0">
                        <label for="employee-to"> Primary Diagnosis: </label>
                        <span class="text-danger mx-1">*</span>
                        <TypeaheadInput
                            placeholder="ICD-10-CM Diagnosis"
                            :getData="diagnosisFetchByDiagnosis"
                            v-on:valueChanged="primaryDiagnosisChanged"
                            :value="primaryDiagnosis.diagnosis"
                            :isError="isPrimaryDiagnosisError"
                        />
                    </div>
                    <div class="col-12 col-lg-4 col-md-4 ps-2 pt-4 mt-1 g-0">
                        <TypeaheadInput
                            placeholder="ICD-10-CM Code"
                            :getData="diagnosisFetchByCode"
                            v-on:valueChanged="primaryDiagnosisChanged"
                            :value="primaryDiagnosis.code"
                            :isError="isPrimaryDiagnosisError"
                        />
                    </div>
                    <div v-if="questionableEncounterCode" class="diagnosis-outline col-12">
                        <p class="ps-2 mb-0"><strong>Questionable Encounter Code Entered</strong></p>
                    </div>
                </div>
            </section>
            <label class="px-4 pt-2" for="employee-to"> Other Diagnoses: </label>
            <section v-for="(input, k) in otherDiagnosis" :key="k" class="d-flex row pt-1 pb-4 px-4 g-0">
                <div v-if="input" class="col-12 col-lg-8 col-md-8 g-0">
                    <TypeaheadInput
                        placeholder="ICD-10-CM Diagnosis"
                        :value="input.diagnosis"
                        :getData="diagnosisFetchByDiagnosis"
                        v-on:valueChanged="(e) => otherDiagnosisChanged(e, k)"
                    />
                </div>
                <div class="col-12 col-lg-4 col-md-4 ps-2 g-0">
                    <TypeaheadInput
                        placeholder="ICD-10-CM Code"
                        :value="input.code"
                        :getData="diagnosisFetchByCode"
                        v-on:valueChanged="(e) => otherDiagnosisChanged(e, k)"
                    />
                    <div class="w-100 d-flex justify-content-end pt-2 pb-1 px-1">
                        <div @click="removeDiagnosis(k)" class="fas fa-window-close fa-sm cursor-pointer"></div>
                    </div>
                </div>
            </section>
            <section class="py-3 px-4 g-0">
                <button @click="addDiagnosis()" class="btn btn-primary me-3">Add Diagnosis</button>
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./PatientDiagnosis.ts"></script>
<style lang="scss" scoped>
.has-warning {
    outline: none;
    border: 2px solid #efac55;
    border-radius: 5px;
    margin: 5px;
}
.diagnosis-outline {
    background-color: #efac55;
    color: white;
    border-radius: 5px;
    margin-top: 0.5em;
}
label {
    margin-top: 0.5rem;
}
</style>
